import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Slider from "react-slick"

import Study1 from "../../../static/space/studycafe/studycafe-study1.jpg"
import Study2 from "../../../static/space/studycafe/studycafe-study2.jpg"
import Study3 from "../../../static/space/studycafe/studycafe-study3.jpg"
import Study4 from "../../../static/space/studycafe/studycafe-study4.jpg"

const Container = styled.div`
  padding: 1vw 0 7vw;

  .title-slide {
    margin: 3vw 0 2vw;
  }
  .study-slide-first img {
    width: 60vw;
    margin-left: auto;
    margin-right: auto;
  }
  .study-slide-first {
    height: 30vw;
  }

  .study-slide-second {
    height: 7.5vw;
  }

  .study-slide-second img {
    width: 14.5vw;
    margin: 0 auto;
    height: 7.5vw;
  }

  .slick-slider {
    width: 60.4vw;
    margin: 3vw auto;
  }

  .slick-next,
  .slick-prev,
  .slick-next:before,
  .slick-prev:before {
    display: none;
  }

  .hide-480 {
    display: block;
  }

  .show-480 {
    display: none;
  }

  @media screen and (max-width: 480px) {
    .hide-480 {
      display: none;
    }

    .show-480 {
      display: block;
    }

    img.slide-img-480 {
      width: 80vw;
      margin: 0 auto 2.5vw;
      display: block;
    }
  }
`

const studycafe_study = () => {
  const [nav1, setNav1] = useState(null)
  const [nav2, setNav2] = useState(null)
  let slider1: any = []
  let slider2: any = []

  useEffect(() => {
    setNav1(slider1)
    setNav2(slider2)
  }, [slider1, slider2])

  return (
    <Container>
      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      <div className="show-480">
        <img className="slide-img-480" src={Study1} alt="스터디존1" />
        <img className="slide-img-480" src={Study2} alt="스터디존2" />
        <img className="slide-img-480" src={Study3} alt="스터디존3" />
        <img className="slide-img-480" src={Study4} alt="스터디존4" />
      </div>
      <div>
        <Slider
          className="title-slide hide-480"
          asNavFor={nav2}
          ref={slider => (slider1 = slider)}
        >
          <div className="study-slide-first">
            <img src={Study1} alt="스터디존1" style={{ marginTop: "-13vw" }} />
          </div>
          <div className="study-slide-first">
            <img src={Study2} alt="스터디존2" />
          </div>
          <div className="study-slide-first">
            <img src={Study3} alt="스터디존3" />
          </div>
          <div className="study-slide-first">
            <img src={Study4} alt="스터디존4" />
          </div>
          <div className="study-slide-first">
            <img src={Study1} alt="스터디존1" style={{ marginTop: "-13vw" }} />
          </div>
          <div className="study-slide-first">
            <img src={Study2} alt="스터디존2" />
          </div>
          <div className="study-slide-first">
            <img src={Study3} alt="스터디존3" />
          </div>
          <div className="study-slide-first">
            <img src={Study4} alt="스터디존4" />
          </div>
        </Slider>
        <Slider
          className="same-title-slide hide-480"
          asNavFor={nav1}
          ref={slider => (slider2 = slider)}
          slidesToShow={4}
          swipeToSlide={true}
          focusOnSelect={true}
          infinite={true}
        >
          <div className="study-slide-second">
            <img src={Study1} alt="스터디존1" />
          </div>
          <div className="study-slide-second">
            <img src={Study2} alt="스터디존2" />
          </div>
          <div className="study-slide-second">
            <img src={Study3} alt="스터디존3" />
          </div>
          <div className="study-slide-second">
            <img src={Study4} alt="스터디존4" />
          </div>
          <div className="study-slide-second">
            <img src={Study1} alt="스터디존1" />
          </div>
          <div className="study-slide-second">
            <img src={Study2} alt="스터디존2" />
          </div>
          <div className="study-slide-second">
            <img src={Study3} alt="스터디존3" />
          </div>
          <div className="study-slide-second">
            <img src={Study4} alt="스터디존4" />
          </div>
        </Slider>
      </div>
    </Container>
  )
}

export default studycafe_study
